// Application settings
export const settings = {
  // PPP interpolation factor (0.0 = US prices only, 1.0 = full PPP adjustment)
  pppInterpolation: 0.8,
};
